// extracted by mini-css-extract-plugin
export var aircallIframe = "_hx-3";
export var fabContainer = "_hx-5";
export var fabRinging = "_hx-6";
export var loadingOverlay = "_hx-4";
export var pulse = "_hx-7";
export var widgetContent = "_hx-2";
export var widgetPanel = "_hx-0";
export var widgetPanelExpanded = "_hx-1";